






import { Vue, Component, Prop } from 'vue-property-decorator';

export type TypographyVariant =
  | 'display1'
  | 'display2'
  | 'headline1'
  | 'headline2'
  | 'headline3'
  | 'headline4'
  | 'headline5'
  | 'headline6'
  | 'label1'
  | 'label2'
  | 'label3'
  | 'label4'
  | 'body1'
  | 'body2'
  | 'body3'
  | 'body4'
  | 'small-caption1'
  | 'small-caption2'
  | 'small-caption3'
  | 'button1'
  | 'button2'
  | 'button3'
  | 'button4';

export type TypographyWeightVariant =
  | 'regular'
  | 'medium'
  | 'semibold'
  | 'bold';

@Component({})
export default class Typography extends Vue {
  @Prop({ default: 'span' }) as?: string;
  @Prop({ default: 'body3' }) variant?: TypographyVariant;
  @Prop({ default: '' }) weight?: TypographyWeightVariant;

  get fontStyles(): Record<string, string> {
    const prefix = `--font-${this.variant}`;

    const weight = this.weight
      ? `var(--font-weight-${this.weight})`
      : `var(${prefix}-weight)`;

    return {
      '--scope-font-size': `var(${prefix}-size)`,
      '--scope-font-weight': weight,
      '--scope-line-height': `var(${prefix}-line-height)`,
      '--scope-letter-spacing': `var(${prefix}-letter)`
    };
  }
}
